<template>
  <div id="screen" class="ui center aligned basic segment" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">My last inspections</h3>
      <input type="checkbox" v-model="dts.mylast" @change="mineonlyChanged"> My inspections only
      <div class="ui">
        <div class="ui fluid buttons">
          <button class="ui small icon button prevbtn" :class="{disabled:dts.skip===0}" style="max-width:3em" @click="prevClicked"><i class="left chevron icon"></i></button>
          <div class="ui small disabled icon button resulttxt">{{ (inspections && inspections.length>0)?(dts.skip + ' - '+ (dts.skip+inspections.length) + ' of ' + dts.cc):'No results' }}</div>
          <button class="ui small icon button nextbtn" :class="{disabled:dts.skip+dts.ps>dts.cc}" style="max-width:3em" @click="nextClicked"><i class="right chevron icon"></i></button>
        </div>
      </div>
      <div class="ui divided items" style="text-align:left">
        <InspectionListitem v-for="ins in inspections" :key="ins._id" :ins="ins" @printInspectionEvent="printInspection"/>
      </div>
      <div class="ui">
        <div class="ui fluid buttons">
          <button class="ui small icon button prevbtn" :class="{disabled:dts.skip===0}" style="max-width:3em" @click="prevClicked"><i class="left chevron icon"></i></button>
          <div class="ui small disabled icon button resulttxt">{{ (inspections && inspections.length>0)?(dts.skip + ' - '+ (dts.skip+inspections.length) + ' of ' + dts.cc):'No results' }}</div>
          <button class="ui small icon button nextbtn" :class="{disabled:dts.skip+dts.ps>dts.cc}" style="max-width:3em" @click="nextClicked"><i class="right chevron icon"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import InspectionListitem from '@/components/InspectionListitem.vue'


  export default {
    components: {
      InspectionListitem
    },
    methods: {
      printInspection(reg, iid) {
        console.log(reg, iid);
        var f = document.getElementById('pframe');
        if (f && f.parent && f.parent.removeChild) f.parent.removeChild(f);

        f = document.createElement('a');
        f.style.display = 'none';
        document.body.append(f);
        f.setAttribute('href',this.$host+'/inspection.print.html?reg='+reg+'&iid='+iid, '_blank');
	f.setAttribute('id','pframe');
	f.dispatchEvent(new Event('click', {bubbles:true}));


//        f = document.createElement('iframe');
//        f.style.display = 'none';
//        document.body.append(f);
//        f.setAttribute('src',this.$host+'/inspection.print.html?reg='+reg+'&iid='+iid, '_blank');
      },
      mineonlyChanged() {
        this.dts.skip = 0;
        this.loadInspections();
      },
      prevClicked() {
        this.dts.skip -= this.dts.ps;
        if (this.dts.skip<0) this.dts.skip=0;

        this.loadInspections();
      },
      nextClicked() {
        this.dts.skip += this.dts.ps;
        if (this.dts.skip > this.dts.c) this.dts.skip -= this.dts.ps;

        this.loadInspections();
      },
      loadInspections() {
        const thiz = this;

        fetch(this.$host+'/searchinspection', {
          method:'POST',
          mode: "cors",
          cache: 'no-cache',
          headers: {
            'Content-type':'application/json'
          },
          credentials:'include',
          body:JSON.stringify(this.dts)
        }).then(res=>res.json()).then(res=>{
          if (res.error){
            console.log('application error #940', res);
            this.$error = {
              title:'Application error #940', 
              message:res.error
            };
          }
          else {
            for (var i=0;i<res.inspections.length; i++) {
              res.inspections[i].inspectionSummary = thiz.$getInspectionSummary(res.inspections[i], thiz);
            }
            thiz.inspections = res.inspections;
            this.dts.cc = res.cc;
          }
        }).catch(err=>{
          console.log('system error #947', err);[0], null
          this.$error = {
            title:'System error #947',
            message:err.message
          };
        });
      }
    },
    data() {
      return {
        inspections: [],
        error:null,
        info:null,
        dts: {cc:0,ps:20,skip:0,mylast:true}
      };
    },
    mounted() {
      this.loadInspections();
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);

      
    },
  }
</script>
